import { Icon } from "simplydo/react/ui";

import { TooltipButton } from "components/lib/UI";

import type { IdeaWithCoverImage } from "../types";

type DownloadCoverImageActionProps = { idea: IdeaWithCoverImage };

const DownloadCoverImageAction = ({ idea }: DownloadCoverImageActionProps) => {
  if (idea.ownerChallenge?.preventIdeaCoverImages || !idea.coverImage) {
    return null;
  }

  return (
    <TooltipButton
      as="a"
      href={idea.coverImageUrl}
      target="_blank"
      rel="noopener noreferrer"
      download={idea.coverImage}
      icon
      tooltip="Download cover image"
    >
      <Icon name="download" />
    </TooltipButton>
  );
};

export default DownloadCoverImageAction;
